import { useEffect, useState } from 'react'
import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@duck/ui'
import { useTar, type TranslationKey } from '@/modules/i18n'

interface ConfirmTabCloseDialogProps {
  open: boolean
  tabLabelKey: TranslationKey | null
  onCancel: () => void
  onConfirm: (dontAskAgain: boolean) => void
}

export const ConfirmTabCloseDialog = ({
  open,
  tabLabelKey,
  onCancel,
  onConfirm,
}: ConfirmTabCloseDialogProps) => {
  const { t } = useTar()
  const [dontAskAgain, setDontAskAgain] = useState(false)

  useEffect(() => {
    if (open) setDontAskAgain(false)
  }, [open])

  const name = tabLabelKey ? t(tabLabelKey) : ''

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onCancel() }}>
      <DialogContent width="xs">
        <DialogHeader>
          <DialogTitle>{t('common.confirmTabCloseBodyNAME', { name })}</DialogTitle>
        </DialogHeader>

        <label className="mt-auto flex items-center gap-2 text-sm text-foreground cursor-pointer select-none">
          <Checkbox
            checked={dontAskAgain}
            onCheckedChange={(v) => setDontAskAgain(v === true)}
          />
          {t('common.dontAskAgain')}
        </label>

        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button autoFocus onClick={() => onConfirm(dontAskAgain)}>
            {t('common.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
